import { useDispatch, } from 'react-redux';
import queryString from 'query-string';

import { productsOperations } from 'store/ducks/products/collection';
import { ProductsFilters } from 'store/ducks/products/collection/types';

const transformFiltersToProperShape = (filters: ProductsFilters) => {
    const basicFilters = [ 'page', 'limit', ];

    return Object
        .entries(filters)
        .reduce((allFilters: ProductsFilters, [ filterKey, filterValue ]) => {
            if (basicFilters.includes(filterKey)) {
                return { ...allFilters, };
            }

            return {
                ...allFilters,
                [filterKey]: Array.isArray(filterValue) ? filterValue : [ filterValue, ],
            };
        }, filters);
};

export const useInitFetchProducts = () => {
    const dispatch = useDispatch();

    return (searchUrlItems: string) => {
        const search = searchUrlItems.replace('?', '');
        const filters = transformFiltersToProperShape(
            queryString.parse(search, { arrayFormat: 'comma' })
        );

        const preparedFilters = Object
            .assign(
                {},
                filters,
                !('page' in filters) && { page: 1, },
                !('limit' in filters) && { limit: 10, },
            );

        dispatch(
            productsOperations.request(preparedFilters)
        );
    };
};
